document.addEventListener("DOMContentLoaded", function () {
  const menus = document.querySelectorAll("header-menu details");

  menus.forEach((menu) => {
    menu.addEventListener("mouseenter", () => {
      menu.setAttribute("open", "true");
    });

    menu.addEventListener("mouseleave", () => {
      // 保持展開，不自動移除 open
    });

    menu.addEventListener("click", (e) => {
      e.stopPropagation();
    });
  });

  document.addEventListener("click", (e) => {
    if (!e.target.closest("header-menu")) {
      menus.forEach((menu) => {
        menu.removeAttribute("open");
      });
    }
  });

  // 延遲關閉 header-menu 下拉選單
  const headerMenuEl = document.querySelector("header-menu");
  if (headerMenuEl) {
    let closeTimer = null;

    headerMenuEl.addEventListener("pointerleave", (e) => {
      closeTimer = setTimeout(() => {
        headerMenuEl.deactivate && headerMenuEl.deactivate(e);
      }, 300); // 300ms 延遲，可依需求調整
    });

    headerMenuEl.addEventListener("pointerenter", () => {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
    });
  }
});